import React from "react";
import { Navigate } from "react-router-dom";
import useAdminAuth from "../hooks/UseAdminAuth";
import { Spinner } from "react-bootstrap";

const AdminProtectedRoute = ({ children }) => {
  const { isLoggedIn, admin, initialized } = useAdminAuth();

  if (!initialized) {
    return (
      <div className="d-flex justify-content-center align-items-center vh-100">
        <Spinner animation="border" role="status">
          <span className="visually-hidden">Loading...</span>
        </Spinner>
      </div>
    );
  }

  if (!isLoggedIn || !admin) {
    return <Navigate to="/adminJaya" />;
  }

  return children;
};

export default AdminProtectedRoute;
